export default __webpack_public_path__ + "static/media/ninaprofile.c2795a01.jpg";